import React from "react";
import axios from "axios";

import Camera from "./canvas/camera/camera.component";
//import Camera from "./canvas/camera/Spin360";

import SelectionContainer from "./canvas/selection/selectionContainer.component";
import MapContainer from "./canvas/map/mapContainer.component";
import AmenitiesContainer from "./canvas/amenities/amenities.container";

import DetailedTour from "./canvas/galleries/detailedTour.component";
import BrochuresComponent from "./canvas/galleries/brochures.component";
import DetailedGallery from "./canvas/galleries/detailedGallery.component";

import Contact from "./canvas/topMenu/contact.component";
import Options from "./canvas/topMenu/options.component";
import QuotationBtn from "./canvas/topMenu/quotation.component";
import AsoleacionBtn from "./canvas/topMenu/asoleacionBtn.component";

import ContactModal from "./canvas/contact/contactModal.component";

import QuotationModal from "./canvas/quotation/quotationModal.component";

import GalleryModal from "./canvas/gallery/galleyModal.component";

import AmenitiesLayouts from "./canvas/layouts/amenities.component";

import Viewer360Three from "./canvas/galleries/viewer360Three.component";

import PropertiesContainer from "./canvas/properties/propertiesContainer.component";
import PropertiesLayouts from "./canvas/layouts/properties.component";

import PropertiesTooltip from "./canvas/layouts/propertiesTooltip.component";

import AsoleacionImages from "./canvas/asoleacion/asoleacionImages.component";
import AsoleacionUI from "./canvas/asoleacion/asoleacionUI.component";

import Hotspots_Lotes from "./canvas/layouts/hotspots_lotes.componet";
import Hotspots from "./canvas/layouts/hotspots.componet";

import DetailedLayouts from "./canvas/layouts/detailed.component";

import TownplanningContainer from "./canvas/townplanning/townplanningContainer.component";
import TownPlanningLayouts from "./canvas/layouts/twonplanning.component";

import HotspotsBtn from "./canvas/layouts/hotspostsbtns.component";

import SalaDeVentas from "./canvas/salaDeVentas/salaDeVentas.container";

import Drag from "./canvas/animations/drag.component";

import SecondaryLegalText from "./canvas/secondaryLegalText/secondaryText.component";

import SidebarQuotation from "./canvas/quotation/sidebarQuotation.component";
import Quotation from "./canvas/quotation/quotation.component";

/*eslint-disable */

interface Canvas {
  mainCameraRef: any;
  secondaryCameraRef: any;
  asoleacionUIRef: any;
  videoRef: any;
  layoutsRef: any;
  asoleacionVideoRef: any;
  optionsRef: any;
  propertiesRef: any;
  tooltipRef: any;
  detailsLayoutRef: any;
  dragRef: any;
  selectionRef: any;
  amenitiesSidebarRef: any;
}

interface Props {
  isIngresoHidden: boolean;
  data: any;
  colorOnHover: any;
}

interface State {
  initFramePOI: number;
  initFramePOIsecondary: number;
  isPreTransition: boolean;
  isSidebarHidden: boolean;

  towerTransition: boolean;
  showGeneralView: boolean;
  showBubbles: boolean;
  showMap: boolean;
  loadingCanvas: boolean;

  cameraAngle: number;
  mainCameraAngle: number;

  hasControl: boolean;

  links: any;
  is180: any;
  openSecondaryCamera: boolean;
  zoom: number;
  leftOffset: number;
  topOffset: number;

  selectionBtnName: string;

  isLocation: boolean;
  isAmenities: boolean;
  isGallery: boolean;
  isProperties: boolean;

  amenitiesData: any;
  amenitiesBubblesTempData: any;
  amenitiesFilterId: string;
  showBillboards: boolean;
  showLayouts: boolean;
  propertiesGeneralJSON: any;
  detailsObject: any;

  isVirtualTourActive: boolean;
  isBrochure: boolean;
  isGalleryActive: boolean;
  isViewer360: boolean;

  isContactModalOpened: boolean;
  isQuotationModalOpened: boolean;
  isAsoleacionModalOpened: boolean;

  asoleacionCurrentVideo: any;
  currentVideoDuration: any;
  currentPlayingTime: any;

  showCamera: boolean;

  showTooltip: boolean;
  clientX: string;
  clientY: string;
  filteredProperty: string;

  propertyFilterArray: any;
  propertyFilterActive: boolean;
  avalabilityAttributesToShow: any;

  asoleacionCurrentSetCount: number;
  asoleacionCurrentSetIndex: number;
  tempAsoleacionData: any;
  asoleacionCurrentSet: any;

  hotspotsData: any;
  showHotspots: boolean;
  showHotspotsAmenties: boolean;
  currentHotspotSelected: string;

  isDetailedSpin: boolean;
  currentSelectedDetailSpin: any;
  detailedSpinLinks: any;
  currentDetailedScript: any;
  showDetailedLayouts: boolean;

  isLoading: boolean;

  isTownplanning: boolean;
  townplanningJSON: any;
  townPlanningFilter: any;
  showTownplanningLayouts: boolean;

  galleryName: string;
  galleryBreadCrumbs: any;
  breadCrumbSelected: number;

  showTowersBtn: boolean;
  detailedGroupID: string;

  generalSecondBatch: any;

  isSalaDeVentasMode: boolean;
  salaDeVentasOpened: boolean;

  tooltipIsRigth: boolean;
  comesFromModalGallery: boolean;

  quotationProperties: any;
  nameQuotation: any;
  phoneQuotation: any;
  emailQuotation: any;
  isCollapseQuotation: any;
  isSendQuotation: any;
  statusQuotation: any;
}
declare const window: any;

class Canvas extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      initFramePOI: 0,
      initFramePOIsecondary: 0,
      isPreTransition: false,
      isSidebarHidden: false,

      towerTransition: false,
      showGeneralView: true,
      showBubbles: false,
      showMap: false,
      loadingCanvas: false,

      cameraAngle: 0,
      mainCameraAngle: 0,

      hasControl: false,

      links: [],
      is180: false,
      openSecondaryCamera: false,

      zoom: 1,
      leftOffset: 0,
      topOffset: 0,

      selectionBtnName: "",

      isLocation: false,
      isAmenities: false,
      isGallery: false,
      isProperties: false,

      amenitiesData: {},
      amenitiesBubblesTempData: {},
      amenitiesFilterId: "",
      showBillboards: false,
      showLayouts: false,
      propertiesGeneralJSON: {},
      detailsObject: [],

      isVirtualTourActive: false,
      isBrochure: false,
      isGalleryActive: false,
      isViewer360: false,

      isContactModalOpened: false,
      isQuotationModalOpened: false,
      isAsoleacionModalOpened: false,

      asoleacionCurrentVideo: {},
      currentPlayingTime: 0,
      currentVideoDuration: 0,

      showCamera: false,

      showTooltip: false,
      clientX: "",
      clientY: "",
      filteredProperty: "",

      propertyFilterArray: [],
      propertyFilterActive: false,
      avalabilityAttributesToShow: ["DISPONIBLE", "VENDIDO", "RESERVADO", "NO DISPONIBLE"],

      asoleacionCurrentSetCount: 0,
      asoleacionCurrentSetIndex: 0,
      tempAsoleacionData: {},
      asoleacionCurrentSet: {},

      hotspotsData: {},
      showHotspots: false,
      showHotspotsAmenties: false,
      currentHotspotSelected: "",

      isDetailedSpin: false,
      currentSelectedDetailSpin: {},
      detailedSpinLinks: [],
      currentDetailedScript: {},
      showDetailedLayouts: false,

      isLoading: false,

      isTownplanning: false,
      townplanningJSON: {},
      townPlanningFilter: "",
      showTownplanningLayouts: false,

      galleryName: "",
      galleryBreadCrumbs: [],
      breadCrumbSelected: -1,

      showTowersBtn: true,
      detailedGroupID: "",

      generalSecondBatch: [],
      isSalaDeVentasMode: false,
      salaDeVentasOpened: false,

      tooltipIsRigth: false,
      comesFromModalGallery: false,

      quotationProperties: [],
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      isCollapseQuotation: false,
      isSendQuotation: false,
      statusQuotation: "",
    };

    this.mainCameraRef = React.createRef();
    this.secondaryCameraRef = React.createRef();
    this.asoleacionUIRef = React.createRef();
    this.videoRef = React.createRef();
    this.layoutsRef = React.createRef();
    this.asoleacionVideoRef = React.createRef();
    this.optionsRef = React.createRef();
    this.propertiesRef = React.createRef();
    this.tooltipRef = React.createRef();
    this.dragRef = React.createRef();
    this.selectionRef = React.createRef();
    this.amenitiesSidebarRef = React.createRef();
  }

  componentDidMount = async () => {
    var canvas = document.getElementById("canvas-content");
    canvas?.addEventListener("click", () => {
      this.optionsRef.current.setState({
        isOptionsOpened: false,
      });
    });

    var detailsObjectTemp: any = [];

    if (this.props.data && this.props.data.details) {
      this.props.data.details.forEach((detailedData: any) => {
        if (detailedData.scripts) {
          detailsObjectTemp.push({
            group: detailedData.group,
            groupId: detailedData.groupID,
            spin: detailedData.spin,
            script: detailedData.json_landscape,
          });
        }
      });
    }

    await fetch("./asoleacion.json")
      .then((response) => response.json())
      .then((data) => {
        this.setState(
          {
            tempAsoleacionData: data,
          },
          () => {
            this.setState(
              {
                asoleacionCurrentSet:
                  this.state.tempAsoleacionData.asoleacion.vistas[0],
              },
              () => {
                this.handleLoadGeneralView();
              }
            );
          }
        );
      });

    await fetch(
      (window.hybrid
        ? ""
        : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
        `${this.props.data.hotspots.json_landscape}`
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          hotspotsData: data,
        });
      });

    this.setState({
      detailsObject: detailsObjectTemp,
    });
  };

  componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): void {
    var canvas = document.getElementById("canvas-content");
    var moving = false;
    canvas?.addEventListener("click", () => {
      this.optionsRef.current.setState({
        isOptionsOpened: false,
      });
    });

    if (
      prevProps.isIngresoHidden !== this.props.isIngresoHidden &&
      this.props.isIngresoHidden === true
    ) {
      setTimeout(() => {
        this.handleLoadSecondBatch();
      }, 1000);
      setTimeout(() => {
        if (this.dragRef.current) {
          this.dragRef.current.setState({
            showDragAnimation: true,
          });
        }
      }, 700);
    }
  }

  handleLoadGeneralView = () => {
    this.setState(
      {
        links: [],
        openSecondaryCamera: false,
      },
      () => {
        var tempArraySpin: any = [];
        if (this.props.data.spin) {
          this.props.data.spin.map((spin: any) => {
            if (spin.type === "General landscape") {
              var data = spin.files;

              data.map((data: any, index: number) => {
                if (index % 2 === 0) {
                  this.setState(
                    (prevState) => ({
                      links: [
                        ...prevState.links,
                        (window.hybrid
                          ? ""
                          : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                          data,
                      ],
                      is180: false,
                    }),
                    () => {
                      this.setState({
                        showCamera: true,
                        showHotspots: true,
                        showHotspotsAmenties: false,
                      });
                    }
                  );
                } else {
                  tempArraySpin.push(
                    (window.hybrid
                      ? ""
                      : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                      data
                  );
                }
              });

              if (tempArraySpin.length === 50) {
                this.setState({
                  generalSecondBatch: tempArraySpin,
                });
              }
            }
          });
        }
      }
    );
  };

  handleLoadSecondBatch = () => {
    if (this.state.generalSecondBatch.length === 50) {
      var counter = 0;
      this.state.generalSecondBatch.forEach((src: any) => {
        new Promise((resolve, reject) => {
          const image = new Image();
          image.src = src;
          image.onload = (e) => {
            counter++;
            if (counter === 50) {
              var finalArray = [];
              for (
                let i = 0;
                i <
                Math.max(
                  this.state.links.length,
                  this.state.generalSecondBatch.length
                );
                i++
              ) {
                finalArray.push(this.state.links[i]);
                finalArray.push(this.state.generalSecondBatch[i]);
              }
              this.setState({
                links: finalArray,
              });
              if (this.layoutsRef.current) {
                this.layoutsRef.current.setState({
                  currentSelectedProperty: "",
                });
              }
            }
          };
        });
      });
    }
  };

  handleStartTransicion = () => {
    this.handleEndTransicion();
  };

  handleSecondaryCameraAngleUpdate = (angle: number) => {
    //console.log(angle);

    this.setState({
      cameraAngle: angle,
      showTooltip: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
    if (this.dragRef.current) {
      this.dragRef.current.setState({
        showDragAnimatio: false,
      });
    }
  };

  handleMainCameraAngleUpdate = (angle: number) => {
    this.setState({
      mainCameraAngle: angle,
      showTooltip: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
    if (this.dragRef.current) {
      this.dragRef.current.setState({
        showDragAnimation: false,
      });
    }
  };

  handleEndTransicion = () => {
    if (this.state.towerTransition) {
      this.setState({
        isPreTransition: false,
        showGeneralView: false,
        showBubbles: false,
        towerTransition: false,
        loadingCanvas: false,
      });
    } else {
      this.setState({
        isPreTransition: false,
      });
    }
  };

  on360Ready = () => {
    this.setState({
      loadingCanvas: false,
    });
  };

  notifyZoomAndOffsets = (zoom: number, leftOffset: any, topOffset: any) => {
    this.setState({
      zoom: zoom,
      leftOffset: leftOffset,
      topOffset: topOffset,
    });
  };

  handleMenuSelection = (slug: string) => {
    this.setState(
      {
        selectionBtnName: slug,
        isLocation: slug === "location",
        isTownplanning: slug === "urbanismo",
        isAmenities: slug === "amenities",
        showHotspotsAmenties: slug === "amenities",
        isGallery: slug === "galleries",
        isProperties: slug === "properties",
        showHotspots: slug === "properties" || slug === "",

        isContactModalOpened: false,
        isQuotationModalOpened: false,
        isGalleryActive: false,
        isBrochure: false,
        isVirtualTourActive: false,
        showTooltip: false,
        openSecondaryCamera: false,
        detailedSpinLinks: [],
        currentSelectedDetailSpin: {},
        currentHotspotSelected: "",
        amenitiesFilterId: "",
        isPreTransition: false,
        initFramePOI: 0,
        isCollapseQuotation: false,
      },
      () => {
        if (this.state.isProperties) {
          this.setState(
            {
              isLoading: true,
              showBillboards: false,
              showDetailedLayouts: false,
              showTownplanningLayouts: false,
              amenitiesBubblesTempData: [],
              openSecondaryCamera: false,
              townplanningJSON: [],
              townPlanningFilter: "",
              detailedSpinLinks: [],
              currentSelectedDetailSpin: {},
              currentHotspotSelected: "",
              amenitiesFilterId: "",
              isPreTransition: false,
              initFramePOI: 0,
            },
            async () => {
              try {
                await fetch(
                  (window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                    `${
                      this.props.data.properties.script.json_landscape
                        ? this.props.data.properties.script.json_landscape
                        : this.props.data.properties.script.json
                    }`
                )
                  .then((response) => response.json())
                  .then((data) => {
                    this.setState(
                      {
                        propertiesGeneralJSON: data,
                      },
                      () => {
                        this.setState({
                          showLayouts: true,
                          isLoading: false,
                        });
                      }
                    );
                  });
              } catch {
                this.setState({
                  showLayouts: false,
                  isLoading: false,
                });
              }
            }
          );
        }
        if (this.state.isAmenities) {
          this.setState(
            {
              isLoading: true,
              showDetailedLayouts: false,
              showTownplanningLayouts: false,
              openSecondaryCamera: false,
              propertiesGeneralJSON: [],
              townplanningJSON: [],
              townPlanningFilter: "",
              showLayouts: false,
              propertyFilterArray: [],
              detailedSpinLinks: [],
              currentSelectedDetailSpin: {},
              currentHotspotSelected: "",
              amenitiesFilterId: "",
              isPreTransition: false,
              initFramePOI: 0,
            },
            async () => {
              try {
                await fetch(
                  (window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                    `${this.props.data.amenities.script.json_landscape}`
                )
                  .then((response) => response.json())
                  .then((data) =>
                    this.setState(
                      {
                        amenitiesBubblesTempData: data,
                      },
                      () => {
                        this.setState({
                          showBillboards: true,
                          isLoading: false,
                        });
                      }
                    )
                  );
              } catch {
                this.setState({
                  showBillboards: false,
                  isLoading: false,
                });
              }
            }
          );
        }
        if (this.state.isTownplanning) {
          this.handleOpenTownPlanning();
          this.setState(
            {
              showBillboards: false,
              showLayouts: false,
              showDetailedLayouts: false,
              propertiesGeneralJSON: [],
              amenitiesBubblesTempData: [],
              townPlanningFilter: "",
              showTownplanningLayouts: false,
              isLoading: true,
              propertyFilterArray: [],
            },
            async () => {
              try {
                await fetch(
                  (window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                    `${this.props.data.townPlanning.json_landscape}`
                )
                  .then((response) => response.json())
                  .then((data) => {
                    this.setState(
                      {
                        townplanningJSON: data,
                      },
                      () => {
                        this.setState({
                          showTownplanningLayouts: true,
                        });
                      }
                    );
                  });
              } catch (err) {
                this.setState({
                  showTownplanningLayouts: false,
                });
              }
            }
          );
        }
        if (this.state.isGallery) {
          this.setState({
            propertiesGeneralJSON: [],
            amenitiesBubblesTempData: [],
            townplanningJSON: [],
            showBillboards: false,
            showLayouts: false,
            showTownplanningLayouts: false,
            townPlanningFilter: "",
            showDetailedLayouts: false,
            currentDetailedScript: {},
            propertyFilterArray: [],
          });
        }
        if (slug === "") {
          this.setState({
            propertiesGeneralJSON: [],
            amenitiesBubblesTempData: [],
            townplanningJSON: [],
            showBillboards: false,
            showLayouts: false,
            showTownplanningLayouts: false,
            townPlanningFilter: "",
            showDetailedLayouts: false,
            currentDetailedScript: {},
            propertyFilterArray: [],
            amenitiesFilterId: "",
            isLoading: false,
          });
          setTimeout(() => {
            this.setState({
              isLoading: false,
            });
          }, 500);
        }
        this.optionsRef.current.setState({
          isOptionsOpened: false,
        });
        if (this.layoutsRef.current) {
          this.layoutsRef.current.setState({
            currentSelectedProperty: "",
          });
        }
      }
    );
  };

  handleamenitiesMenySelection = (galleryType: any) => {
    this.setState({
      isVirtualTourActive:
        galleryType.name === "Recorridos" || galleryType.name === "Videos",
      isBrochure: galleryType.name === "Brochures",
      isGalleryActive:
        galleryType.name === "Planos" ||
        galleryType.name === "Renders 2D" ||
        galleryType.name === "Fotos 2D",
      isViewer360:
        galleryType.name === "Renders 360°" ||
        galleryType.name === "vistas por piso 360°" ||
        galleryType.name === "Fotos 360°",
      amenitiesData: galleryType,
      galleryName: galleryType.name,
      galleryBreadCrumbs: [],
      comesFromModalGallery: false,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleAmenitiesBillboardFilter = (id: string) => {
    this.setState({
      amenitiesFilterId: id,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleamenitiesFilter = (id: string, frame: number) => {
    this.setState({
      amenitiesFilterId: id,
      isPreTransition: true,
      initFramePOI: frame,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleGalleriesSelection = (
    galleryType: any,
    breadCrumbs: any,
    comesFromModalGallery: boolean
  ) => {
    this.setState({
      isVirtualTourActive:
        galleryType.name === "Recorridos" || galleryType.name === "Videos",
      isBrochure: galleryType.name === "Brochures",
      isGalleryActive:
        galleryType.name === "Planos" ||
        galleryType.name === "Renders 2D" ||
        galleryType.name === "Fotos 2D",
      isViewer360:
        galleryType.name === "Renders 360°" ||
        galleryType.name === "vistas por piso 360" ||
        galleryType.name === "Fotos 360°",
      amenitiesData: galleryType,
      galleryName: galleryType.name,
      galleryBreadCrumbs: breadCrumbs,
      showTooltip: false,
      comesFromModalGallery: comesFromModalGallery,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleCloseVirtualTour = () => {
    this.setState({
      isVirtualTourActive: false,
      isGallery: false,
      selectionBtnName:
        this.state.isAmenities || this.state.isDetailedSpin
          ? this.state.selectionBtnName
          : "",
      showHotspots:
        this.state.isAmenities || this.state.isDetailedSpin ? false : true,
      showHotspotsAmenties: this.state.isAmenities ? true : false,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleCloseBrochure = () => {
    this.setState({
      isBrochure: false,
      isGallery: false,
      selectionBtnName:
        this.state.isAmenities || this.state.isDetailedSpin
          ? this.state.selectionBtnName
          : "",
      showHotspots:
        this.state.isAmenities || this.state.isDetailedSpin ? false : true,
      showHotspotsAmenties: this.state.isAmenities ? true : false,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleCloseGallery = () => {
    this.setState({
      isGalleryActive: false,
      isGallery: false,
      selectionBtnName:
        this.state.isAmenities || this.state.isDetailedSpin
          ? this.state.selectionBtnName
          : "",
      showHotspots:
        this.state.isAmenities || this.state.isDetailedSpin ? false : true,
      showHotspotsAmenties: this.state.isAmenities ? true : false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleClose360 = () => {
    this.setState({
      isViewer360: false,
      isGallery: false,
      selectionBtnName:
        this.state.isAmenities || this.state.isDetailedSpin
          ? this.state.selectionBtnName
          : "",
      showHotspots:
        this.state.isAmenities || this.state.isDetailedSpin ? false : true,
      showHotspotsAmenties: this.state.isAmenities ? true : false,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleOpenContactModal = () => {
    this.setState({
      isContactModalOpened: !this.state.isContactModalOpened,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleOpenQuotation = () => {
    this.setState(
      {
        isCollapseQuotation: !this.state.isCollapseQuotation,
        /* showTooltip: false, */
      },
      () => {
        if (this.state.isSendQuotation) {
          this.setState({
            nameQuotation: "",
            phoneQuotation: "",
            emailQuotation: "",
            quotationProperties: [],
            isSendQuotation: false,
            statusQuotation: "",
            isCollapseQuotation: false,
          });
        }
      }
    );
  };

  handleOpenQuotationModal = () => {
    this.setState({
      isQuotationModalOpened: !this.state.isQuotationModalOpened,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleOpenAsoleacionModal = () => {
    this.setState(
      {
        isAsoleacionModalOpened: !this.state.isAsoleacionModalOpened,
      },
      () => {
        this.setState({
          asoleacionCurrentVideo: this.state.isAsoleacionModalOpened
            ? this.props.data.asoleacion.vistas[0]
            : {},
          showTooltip: false,
        });
      }
    );
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleChangeAsoleacionVideo = (payload: any) => {
    this.setState({
      asoleacionCurrentVideo: payload,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
  };

  handlePlayVideo = () => {
    var video = this.videoRef.current.currentVideo.current;
    video.currentTime = 0;
    video.play();
  };

  handleChangeVideoTime = (e: any) => {
    var video = this.videoRef.current.currentVideo.current;
    video.pause();
    video.currentTime = e.target.value;
    this.setState({
      currentPlayingTime: e.target.value,
      showTooltip: false,
    });
  };

  handleCloseGalleryModal = () => {
    this.setState({
      isGallery: false,
      selectionBtnName: this.state.isAmenities
        ? this.state.selectionBtnName
        : "",
      showHotspots: this.state.isAmenities ? false : true,
      showHotspotsAmenties: this.state.isAmenities ? true : false,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleShowTooltip = (
    currentPropertyId: string,
    event: any,
    xPosition: any,
    displacemnet: any,
    isRigth: boolean
  ) => {
    this.setState({
      tooltipIsRigth: isRigth,
      clientX:
        event.type.indexOf("touch") === 0
          ? event.changedTouches[0].clientX
          : xPosition + displacemnet,
      clientY:
        event.type.indexOf("touch") === 0
          ? event.changedTouches[0].clientY
          : event.clientY,
      showTooltip: true,
      filteredProperty: currentPropertyId,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
  };

  handleHideTooltip = () => {
    this.setState(
      {
        showTooltip: false,
      },
      () => {
        if (this.layoutsRef.current) {
          this.layoutsRef.current.clearLayoutFilter();
        }
      }
    );
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handlePropertiesFilter = (filter: any) => {
    console.log(filter);
    
    var tempFilterArray: any = {};
    this.props.data.properties.attributes.forEach((attribute: any) => {
      if (filter[attribute.id] !== "") {
        tempFilterArray[attribute.id] = filter[attribute.id];
      }
    });

    this.setState({
      propertyFilterArray: tempFilterArray,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handlePropertiesFilterDetailed = (filterId: string, filterValue: string) => {
    var word = "";
    var wordId = "";
    this.props.data.properties.attributes.forEach((attribute: any) => {
      if (attribute.type === "Hierarchical" && attribute.padre !== null) {
        this.setState({
          detailedGroupID: attribute.id,
        });
      }
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleFilterAvailability = (payload: string) => {
    var filter = this.state.avalabilityAttributesToShow;
    if (filter.includes(payload)) {
      filter.splice(filter.indexOf(payload), 1);
    } else {
      filter.push(payload);
    }
    this.setState({
      avalabilityAttributesToShow: filter,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleAsoleacionImagesCount = () => {
    this.setState({
      asoleacionCurrentSetCount:
        this.asoleacionVideoRef.current.state.currentAsoleacionSet.length,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleAsoleacionChangeIndex = (index: number) => {
    this.setState({
      asoleacionCurrentSetIndex: index,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleChangeAsoleacionTime = (index: number) => {
    if (this.state.asoleacionCurrentSetIndex > index) {
      const changeIndexInterval = setInterval(() => {
        if (this.state.asoleacionCurrentSetIndex > index) {
          this.setState({
            asoleacionCurrentSetIndex: this.state.asoleacionCurrentSetIndex - 1,
          });
        } else {
          clearInterval(changeIndexInterval);
        }
      }, 50);
    }
    if (this.state.asoleacionCurrentSetIndex < index) {
      const changeIndexInterval = setInterval(() => {
        if (this.state.asoleacionCurrentSetIndex < index) {
          this.setState({
            asoleacionCurrentSetIndex: this.state.asoleacionCurrentSetIndex + 1,
          });
        } else {
          clearInterval(changeIndexInterval);
        }
      }, 50);
    }
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleChangeAsoleacionSet = (set: any) => {
    this.setState({
      asoleacionCurrentSet: set,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleAutoplayAsoleacion = () => {
    this.setState(
      {
        asoleacionCurrentSetIndex: 0,
        showTooltip: false,
      },
      () => {
        if (
          this.state.asoleacionCurrentSetIndex <
          this.state.asoleacionCurrentSetCount - 1
        ) {
          const changeIndexInterval = setInterval(() => {
            if (
              this.state.asoleacionCurrentSetIndex <
              this.state.asoleacionCurrentSetCount - 1
            ) {
              this.setState({
                asoleacionCurrentSetIndex:
                  this.state.asoleacionCurrentSetIndex + 1,
              });
            } else {
              clearInterval(changeIndexInterval);
            }
          }, 50);
        }
      }
    );
  };

  handleSelectedHotspot = (name: string) => {
    this.setState(
      {
        currentHotspotSelected: name,
        showTooltip: false,
      },
      () => {
        var tempDetailsObject: any = {};
        this.state.detailsObject.forEach((detailedObject: any) => {
          console.log(
            detailedObject.group,
            "===",
            this.state.currentHotspotSelected
          );

          if (detailedObject.group === this.state.currentHotspotSelected) {
            tempDetailsObject = detailedObject;
          }
        });

        if (
          Object.keys(tempDetailsObject).length > 0 &&
          tempDetailsObject.spin !== null
        ) {
          this.props.data.spin.forEach((spin: any) => {
            if (tempDetailsObject.spin === spin.id) {
              var files: any = [];
              spin.files.forEach((file: string) => {
                files.push(
                  (window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                    file
                );
              });
              tempDetailsObject["files"] = files;
            }
          });

          this.handleShowDetailedSpin(tempDetailsObject);
        }
      }
    );
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleShowDetailedSpin = (payload: any) => {
    this.setState(
      {
        currentSelectedDetailSpin: payload,
        isLoading: true,
        isDetailedSpin: true,
        showTooltip: false,
      },
      () => {
        if (this.state.currentSelectedDetailSpin.files) {
          this.handlePropertiesFilterDetailed(
            this.state.currentSelectedDetailSpin.groupId,
            this.state.currentSelectedDetailSpin.group
          );
          console.log(this.state.currentSelectedDetailSpin.files);

          this.setState(
            (prevState) => ({
              detailedSpinLinks: this.state.currentSelectedDetailSpin.files,
              is180: this.state.currentSelectedDetailSpin.files === 25,
            }),
            async () => {
              try {
                await fetch(
                  (window.hybrid
                    ? ""
                    : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                    this.state.currentSelectedDetailSpin.script
                )
                  .then((response) => response.json())
                  .then((data) => {
                    this.setState(
                      {
                        showHotspots: false,
                        showHotspotsAmenties: false,
                        showLayouts: false,
                        currentDetailedScript: data,
                        //showDetailedLayouts: true
                      },
                      () => {
                        this.handlePreloadImages(this.state.detailedSpinLinks);
                      }
                    );
                  });
              } catch {
                this.setState(
                  {
                    showHotspots: false,
                    showHotspotsAmenties: false,
                    showLayouts: false,
                    showDetailedLayouts: false,
                  },
                  () => {
                    this.handlePreloadImages(this.state.detailedSpinLinks);
                  }
                );
              }
            }
          );
        }
      }
    );
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handlePreloadImages = (payload: any) => {
    let counter = 0;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        payload.forEach((imageSrc: any) => {
          const image = new Image();
          image.src = imageSrc;
          image.onload = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                showDetailedLayouts: true,
                selectionBtnName: "properties",
                isProperties: true,
                isLoading: false,
                showTooltip: false,
              });
            }
          };
        });
      }
    );
  };

  handlePreloadImagesTownplanning = (payload: any) => {
    let counter = 0;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        payload.forEach((imageSrc: any) => {
          const image = new Image();
          image.src = imageSrc;
          image.onload = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                isLoading: false,
                showTooltip: false,
              });
            }
          };
          image.onloadedmetadata = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                isLoading: false,
              });
            }
          };
        });
      }
    );
  };

  handleOpenTownPlanning = () => {
    this.props.data.spin.forEach((spin: any) => {
      if (spin.type === "Urbanismo landscape") {
        spin.files.forEach((file: any, index: number) => {
          this.setState(
            (prevState) => ({
              detailedSpinLinks: [
                ...prevState.detailedSpinLinks,
                (window.hybrid
                  ? ""
                  : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                  file,
              ],
              is180: spin.files.length === 25,
              showTooltip: false,
            }),
            () => {
              if (index === spin.files.length - 1) {
                this.handlePreloadImagesTownplanning(
                  this.state.detailedSpinLinks
                );
              }
            }
          );
        });
      }
    });
  };

  handleSelectTownPlanningFilter = (payload: string) => {
    this.setState({
      townPlanningFilter: payload,
      showTownplanningLayouts: true,
      showTooltip: false,
    });
  };

  handleCloseDetailedSpin = () => {
    this.setState(
      {
        showTooltip: false,
        openSecondaryCamera: false,
        detailedSpinLinks: [],
        currentSelectedDetailSpin: {},
        currentHotspotSelected: "",
        showDetailedLayouts: false,
        currentDetailedScript: {},
        isDetailedSpin: false,
      },
      () => {
        this.handleMenuSelection("properties");
      }
    );
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleGetBreadCrumbSelected = (index: number) => {
    this.setState({
      breadCrumbSelected: index + 1,
      isVirtualTourActive: false,
      isBrochure: false,
      isGalleryActive: false,
      isViewer360: false,
      galleryName: "",
      galleryBreadCrumbs: [],
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleOpenAmenitiesSpin = (spin: any) => {
    this.setState({
      showHotspotsAmenties: false,
    })
    spin.files.forEach((file: any, index: number) => {
      this.setState(
        (prevState) => ({
          detailedSpinLinks: [
            ...prevState.detailedSpinLinks,
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + file,
          ],
          is180: spin.files.length === 25,
          showBillboards: false,
        }),
        () => {
          if (index === spin.files.length - 1) {
            this.handlePreloadImagesTownplanning(this.state.detailedSpinLinks);
          }
        }
      );
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleCloseAmenitieSpin = () => {
    this.setState({
      detailedSpinLinks: [],
      is180: false,
      openSecondaryCamera: false,
      showBillboards: true,
      showTooltip: false,
      showHotspotsAmenties: true,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
  };

  handleOpenPropertiesSpin = (spin: any) => {
    this.setState({
      showHotspots: false,
      showHotspotsAmenties: false,
      showLayouts: false,
      showDetailedLayouts: false,
      showTooltip: false,
      openSecondaryCamera: false,
      detailedSpinLinks: [],
      currentSelectedDetailSpin: {},
      currentHotspotSelected: "",
      currentDetailedScript: {},
      isDetailedSpin: false,
    });
    //this.handleHideTooltip()
    spin.files.forEach((file: any, index: number) => {
      this.setState(
        (prevState) => ({
          detailedSpinLinks: [
            ...prevState.detailedSpinLinks,
            (window.hybrid
              ? ""
              : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + file,
          ],
          is180: spin.files.length === 25,
          showBillboards: false,
        }),
        () => {
          if (index === spin.files.length - 1) {
            this.handlePreloadImagesTownplanning(this.state.detailedSpinLinks);
          }
        }
      );
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleClosePropertiesSpin = () => {
    this.setState({
      detailedSpinLinks: [],
      is180: false,
      openSecondaryCamera: false,
      showBillboards: true,
      showTooltip: false,
    });
    this.optionsRef.current.setState({
      isOptionsOpened: false,
    });
  };

  handleShowTowersBtn = () => {
    this.setState({
      showTowersBtn: !this.state.showTowersBtn,
    });
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleChangeToSalaDeVentas = () => {
    this.setState(
      {
        isSalaDeVentasMode: !this.state.isSalaDeVentasMode,
        salaDeVentasOpened: true,
        showTooltip: false,
      },
      () => {
        setTimeout(() => {
          this.setState({
            salaDeVentasOpened: false,
          });
        }, 2000);
      }
    );
    if (this.layoutsRef.current) {
      this.layoutsRef.current.setState({
        currentSelectedProperty: "",
      });
    }
  };

  handleChangeBreadCrumbSelected = (payload: number) => {
    this.setState({
      breadCrumbSelected: payload,
    });
  };

  handleSetPropertyInQuotation = (property: any) => {
    this.setState(
      {
        quotationProperties: [...this.state.quotationProperties, property],
      },
      () => {
        console.log(this.state.quotationProperties);
      }
    );
  };

  handleRemovePropertyInQuotation = (property: any) => {
    // Verificar si el ID del elemento a agregar ya existe en el arreglo
    const existingIndex = this.state.quotationProperties.findIndex(
      (item: any) => item.id === property.id
    );

    if (existingIndex !== -1) {
      // Si el elemento ya existe, lo eliminamos del arreglo usando filter
      const updatedProperties = this.state.quotationProperties.filter(
        (item: any) => item.id !== property.id
      );

      // Actualizamos el estado con el arreglo sin el elemento existente
      this.setState(
        {
          quotationProperties: updatedProperties,
        },
        () => {
          console.log("Estado actualizado:", this.state.quotationProperties);
        }
      );
    } /* else {
      // Si el elemento no existe, lo agregamos al arreglo
      this.setState(
        {
          quotationProperties: [...this.state.quotationProperties, property],
        },
        () => {
          console.log("Estado actualizado:", this.state.quotationProperties);
        }
      );
    } */
  };

  handleSendQuotation = async (params: any) => {
    params.properties = this.state.quotationProperties;
    params.project = window.project_id;
    let res: any = await axios.post(
      "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
      params
    );

    this.setState({
      isSendQuotation: true,
      statusQuotation: res.data.statusCode,
    });
  };

  handleBackQuotation = async (params: any) => {
    this.setState({
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      quotationProperties: [],
      isSendQuotation: false,
      statusQuotation: "",
      isCollapseQuotation: false,
    });
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.state.showCamera
            ? "maqueta-page fade-in"
            : "maqueta-page fade-out"
        }
      >
        {this.state.showCamera ? (
          <div className="canvas-content">
            <div className="canvas-3d" id="canvas-content">
              <Camera
                useSubdirectories={false}
                links={this.state.links}
                initFramePOI={this.state.initFramePOI}
                isPreTransition={this.state.isPreTransition}
                handleStartTransicion={this.handleStartTransicion}
                handleAngleUpdate={this.handleMainCameraAngleUpdate}
                onReady={() => {
                  this.setState({ loadingCanvas: false });
                }}
                is180={false}
                notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                ref={this.mainCameraRef}
                hasControl={this.state.hasControl}
                handleHideTooltip={this.handleHideTooltip}
              />
              {
                <div
                  className={
                    this.state.openSecondaryCamera
                      ? "secondary-camera fade-in"
                      : "secondary-camera fade-out"
                  }
                >
                  <Camera
                    useSubdirectories={false}
                    links={this.state.detailedSpinLinks}
                    onReady={() => {
                      this.setState({ loadingCanvas: false });
                    }}
                    initFramePOI={this.state.initFramePOIsecondary}
                    isPreTransition={this.state.isPreTransition}
                    is180={this.state.is180}
                    //onForceUpdateBubbles={this.forceUpdateBubbles}
                    secondary={true}
                    handleAngleUpdate={this.handleSecondaryCameraAngleUpdate}
                    //rotateForBubble={() => {}}
                    handleRotateForBubbleEnded={() => {}}
                    //bubbleAngle={() => {}}
                    handleStartTransicion={this.handleStartTransicion}
                    notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                    ref={this.secondaryCameraRef}
                    hasControl={this.state.hasControl}
                    handleHideTooltip={this.handleHideTooltip}
                  />
                </div>
              }
            </div>
          </div>
        ) : null}
        {this.state.showBillboards &&
        this.state.amenitiesBubblesTempData.amenities_coord_file ? (
          <AmenitiesLayouts
            amenitiesData={this.state.amenitiesBubblesTempData}
            amenitiesImages={this.props.data.amenities}
            amenityFilter={this.state.amenitiesFilterId}
            colorsData={this.props.data.colors}
            angle={this.state.mainCameraAngle}
            show={this.state.showBillboards}
            amenitiesProps={this.props.data.amenities}
            handleAmenitiesBillboardFilter={this.handleAmenitiesBillboardFilter}
            links={this.state.links}
          />
        ) : null}
        {this.state.showLayouts ? (
          <PropertiesLayouts
            ref={this.layoutsRef}
            showLayouts={this.state.showLayouts}
            angle={this.state.mainCameraAngle}
            scriptData={this.state.propertiesGeneralJSON}
            handleShowTooltip={this.handleShowTooltip}
            colorsData={this.props.data.colors}
            propertiesData={this.props.data.properties}
            propertyFilterArray={this.state.propertyFilterArray}
            avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
            hasDispo={this.props.data.properties.disponibilidad}
            links={this.state.links}
          />
        ) : null}
        {this.state.showDetailedLayouts ? (
          <DetailedLayouts
            ref={this.layoutsRef}
            showDetailedLayouts={this.state.showDetailedLayouts}
            angle={this.state.cameraAngle}
            scriptData={this.state.currentDetailedScript}
            handleShowTooltip={this.handleShowTooltip}
            colorsData={this.props.data.colors}
            propertiesData={this.props.data.properties}
            propertyFilterArray={this.state.propertyFilterArray}
            avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
            hasDispo={this.props.data.properties.disponibilidad}
          />
        ) : null}
        {this.state.showTownplanningLayouts ? (
          <TownPlanningLayouts
            isTownPlanning={this.state.showTownplanningLayouts}
            scriptData={this.state.townplanningJSON}
            townPlanningFilter={this.state.townPlanningFilter}
            angle={this.state.cameraAngle}
            attributesData={this.props.data.properties.attributes}
          />
        ) : null}
        {this.state.showHotspots &&
        this.state.hotspotsData.hotspots_coord_file &&
        this.props.data?.model === "LOTES/CASAS" ? (
          <Hotspots_Lotes
            showHotspots={this.state.showHotspots}
            hotspotsData={this.state.hotspotsData}
            angle={this.state.mainCameraAngle}
            handleSelectedHotspot={this.handleSelectedHotspot}
            colorsData={this.props.data.colors}
            showTowersBtn={this.state.showTowersBtn}
            propertiesData={this.props.data.properties}
            links={this.state.links}
            colorOnHover={this.props.colorOnHover}
          />
        ) : (this.state.showHotspots || this.state.showHotspotsAmenties) &&
          this.state.hotspotsData.hotspots_coord_file &&
          this.props.data?.model === "TORRES" ? (
          <Hotspots
            showHotspotsAmenties={this.state.showHotspotsAmenties}
            showHotspots={this.state.showHotspots}
            hotspotsData={this.state.hotspotsData}
            angle={this.state.mainCameraAngle}
            handleSelectedHotspot={this.handleSelectedHotspot}
            colorsData={this.props.data.colors}
            showTowersBtn={this.state.showTowersBtn}
            propertiesData={this.props.data.properties}
            links={this.state.links}
            colorOnHover={this.props.colorOnHover}
          />
        ) : null}
        {this.props.data?.isContact && !this.state.isSalaDeVentasMode ? (
          <Contact
            colorsData={this.props.data.colors}
            handleOpenContactModal={this.handleOpenContactModal}
            isSalaDeVentasMode={this.state.isSalaDeVentasMode}
          />
        ) : null}
        <Options
          ref={this.optionsRef}
          colorsData={this.props.data.colors}
          handleChangeToSalaDeVentas={this.handleChangeToSalaDeVentas}
          isSalaDeVentasMode={this.state.isSalaDeVentasMode}
        />

        {this.props.data.quotation ? (
          <QuotationBtn
            handleOpenQuotationModal={this.handleOpenQuotationModal}
            isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
            isQuotationModalOpened={this.state.isQuotationModalOpened}
          />
        ) : null}
        {this.props.data.asoleacion ? (
          <AsoleacionBtn
            colorsData={this.props.data.colors}
            handleOpenAsoleacionModal={this.handleOpenAsoleacionModal}
          />
        ) : null}

        <AmenitiesContainer
          isAmenities={this.state.isAmenities}
          amenitiesData={this.props.data.amenities}
          colorsData={this.props.data.colors}
          handleamenitiesMenySelection={this.handleamenitiesMenySelection}
          handleamenitiesFilter={this.handleamenitiesFilter}
          handleMenuSelection={this.handleMenuSelection}
          amenitiesFilterId={this.state.amenitiesFilterId}
          handleOpenAmenitiesSpin={this.handleOpenAmenitiesSpin}
          handleCloseAmenitieSpin={this.handleCloseAmenitieSpin}
        />
        <PropertiesContainer
          isProperties={this.state.isProperties}
          colorsData={this.props.data.colors}
          inmueblesData={this.props.data}
          handlePropertiesFilter={this.handlePropertiesFilter}
          avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
          handleFilterAvailability={this.handleFilterAvailability}
          handleMenuSelection={this.handleMenuSelection}
          isDetailed={this.state.currentSelectedDetailSpin}
          handleCloseDetailedSpin={this.handleCloseDetailedSpin}
          hasDispo={this.props.data.properties.disponibilidad}
          detailedGroupID={this.state.detailedGroupID}
          isSalaVentasMode={this.state.isSalaDeVentasMode}
          layoutsRef={this.layoutsRef}
          handleHideTooltip={this.handleHideTooltip}
        />
        <TownplanningContainer
          isTownplannig={this.state.isTownplanning}
          colorsData={this.props.data.colors}
          attributesData={this.props.data.properties.attributes}
          handleSelectTownPlanningFilter={this.handleSelectTownPlanningFilter}
          handleMenuSelection={this.handleMenuSelection}
        />

        {
          <PropertiesTooltip
            ref={this.tooltipRef}
            clientX={this.state.clientX}
            clientY={this.state.clientY}
            showTooltip={this.state.showTooltip}
            handleHideTooltip={this.handleHideTooltip}
            filteredProperty={this.state.filteredProperty}
            propertiesData={this.props.data.properties}
            spinsData={
              this.props.data?.spin?.length > 0
                ? this.props.data?.spin?.filter(
                    (e: any) => e.grou === "Inmueble"
                  )
                : []
            }
            handleamenitiesMenySelection={this.handleamenitiesMenySelection}
            tooltipIsRigth={this.state.tooltipIsRigth}
            handleOpenPropertiesSpin={this.handleOpenPropertiesSpin}
            handleSetPropertyInQuotation={this.handleSetPropertyInQuotation}
            handleRemovePropertyInQuotation={
              this.handleRemovePropertyInQuotation
            }
            quotationProperties={this.state.quotationProperties}
            colors={this.props.data.colors}
            isQuotation={this.props.data.cotizaciion}
          />
        }
        <Drag ref={this.dragRef} />
        {/* this.state.isLocation ?
          <MapContainer
            isLocation={this.state.isLocation}
            locationData={this.props.data.location}
            colorsData={this.props.data.colors}
            handleMenuSelection={this.handleMenuSelection}
          />:null
         */}
        <MapContainer
          isLocation={this.state.isLocation}
          locationData={this.props.data.location}
          colorsData={this.props.data.colors}
          handleMenuSelection={this.handleMenuSelection}
        />
        <SelectionContainer
          isIngresoHidden={this.props.isIngresoHidden}
          data={this.props.data}
          handleMenuSelection={this.handleMenuSelection}
          selectionBtnName={this.state.selectionBtnName}
        />
        {this.state.showHotspots &&
        this.state.hotspotsData.hotspots_coord_file &&
        !this.state.isSalaDeVentasMode ? (
          <HotspotsBtn
            colorsData={this.props.data.colors}
            handleShowTowersBtn={this.handleShowTowersBtn}
            showTowersBtn={this.state.showTowersBtn}
            propertiesData={this.props.data.properties}
            isSalaDeVentasMode={this.state.isSalaDeVentasMode}
          />
        ) : null}
        {this.state.isSalaDeVentasMode ? (
          <div className="div-contact-hotspots-sala-de-ventas">
            {this.props.data?.isContact ? (
              <Contact
                colorsData={this.props.data.colors}
                handleOpenContactModal={this.handleOpenContactModal}
                isSalaDeVentasMode={this.state.isSalaDeVentasMode}
              />
            ) : null}
            {this.state.showHotspots &&
            this.state.hotspotsData.hotspots_coord_file ? (
              <HotspotsBtn
                colorsData={this.props.data.colors}
                handleShowTowersBtn={this.handleShowTowersBtn}
                showTowersBtn={this.state.showTowersBtn}
                propertiesData={this.props.data.properties}
                isSalaDeVentasMode={this.state.isSalaDeVentasMode}
              />
            ) : null}
          </div>
        ) : null}
        {this.state.isGallery ? (
          <GalleryModal
            galleryData={this.props.data.galleries}
            colorsData={this.props.data.colors}
            isGallery={this.state.isGallery}
            handleGalleriesSelection={this.handleGalleriesSelection}
            handleCloseGalleryModal={this.handleCloseGalleryModal}
            breadCrumbSelected={this.state.breadCrumbSelected}
            handleChangeBreadCrumbSelected={this.handleChangeBreadCrumbSelected}
          />
        ) : null}
        {this.state.isVirtualTourActive ? (
          <DetailedTour
            isVirtualTourActive={this.state.isVirtualTourActive}
            amenityData={this.state.amenitiesData}
            handleCloseVirtualTour={this.handleCloseVirtualTour}
            colorsData={this.props.data.colors}
            galleryName={this.state.galleryName}
            breadCrumbs={this.state.galleryBreadCrumbs}
            handleGetBreadCrumbSelected={this.handleGetBreadCrumbSelected}
            comesFromModalGallery={this.state.comesFromModalGallery}
          />
        ) : null}
        {this.state.isBrochure ? (
          <BrochuresComponent
            isBrochureActive={this.state.isBrochure}
            amenityData={this.state.amenitiesData}
            handleCloseBrochure={this.handleCloseBrochure}
            colorsData={this.props.data.colors}
            galleryName={this.state.galleryName}
            breadCrumbs={this.state.galleryBreadCrumbs}
            handleGetBreadCrumbSelected={this.handleGetBreadCrumbSelected}
            comesFromModalGallery={this.state.comesFromModalGallery}
          />
        ) : null}

        {this.state.isGalleryActive ? (
          <DetailedGallery
            isGalleryActive={this.state.isGalleryActive}
            amenityData={this.state.amenitiesData}
            colorsData={this.props.data.colors}
            handleCloseGallery={this.handleCloseGallery}
            galleryName={this.state.galleryName}
            breadCrumbs={this.state.galleryBreadCrumbs}
            handleGetBreadCrumbSelected={this.handleGetBreadCrumbSelected}
            comesFromModalGallery={this.state.comesFromModalGallery}
          />
        ) : null}
        {this.state.isViewer360 ? (
          <Viewer360Three
            isViewer360={this.state.isViewer360}
            amenityData={this.state.amenitiesData}
            colorsData={this.props.data.colors}
            handleCloseGallery={this.handleClose360}
            galleryName={this.state.galleryName}
            breadCrumbs={this.state.galleryBreadCrumbs}
            handleGetBreadCrumbSelected={this.handleGetBreadCrumbSelected}
            comesFromModalGallery={this.state.comesFromModalGallery}
          />
        ) : null}

        {this.props.isIngresoHidden ? (
          <ContactModal
            isContactModalOpened={this.state.isContactModalOpened}
            logoConstructora={this.props.data.logo_constructora}
            colorsData={this.props.data.colors}
            contactData={this.props.data.contact}
            handleCloseContactModal={this.handleOpenContactModal}
          />
        ) : null}
        <QuotationModal
          isQuotationModalOpened={this.state.isQuotationModalOpened}
          handleOpenQuotationModal={this.handleOpenQuotationModal}
        />
        <AsoleacionImages
          ref={this.asoleacionVideoRef}
          handleAsoleacionImagesCount={this.handleAsoleacionImagesCount}
          asoleacionCurrentSetIndex={this.state.asoleacionCurrentSetIndex}
          isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
          asoleacionCurrentSet={this.state.asoleacionCurrentSet}
        />

        {this.state.tempAsoleacionData.asoleacion &&
        this.state.tempAsoleacionData.asoleacion.times &&
        this.state.tempAsoleacionData.asoleacion.vistas ? (
          <AsoleacionUI
            handleAsoleacionImagesCount={this.handleAsoleacionImagesCount}
            asoleacionCurrentSetCount={this.state.asoleacionCurrentSetCount}
            handleAsoleacionChangeIndex={this.handleAsoleacionChangeIndex}
            isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
            handleOpenAsoleacionModel={this.handleOpenAsoleacionModal}
            //asolacionData = {this.props.data.asoleacion}
            asolacionData={this.state.tempAsoleacionData.asoleacion}
            colorsData={this.props.data.colors}
            handleChangeAsoleacionTime={this.handleChangeAsoleacionTime}
            asoleacionCurrentSetIndex={this.state.asoleacionCurrentSetIndex}
            handleChangeAsoleacionSet={this.handleChangeAsoleacionSet}
            handleAutoplayAsoleacion={this.handleAutoplayAsoleacion}
            asoleacionCurrentSet={this.state.asoleacionCurrentSet}
          />
        ) : null}
        <SalaDeVentas
          isSalaDeVentasMode={this.state.isSalaDeVentasMode}
          salaDeVentasOpened={this.state.salaDeVentasOpened}
        />

        {<SecondaryLegalText data={this.props.data} />}

        {
          <div
            className={
              this.state.isLoading
                ? "canvas-loading fade-in"
                : "canvas-loading fade-out"
            }
          >
            <svg
              className="loader-circle-canvas"
              viewBox="0 0 150 150"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="internal-circle-canvas"
                cx="75"
                cy="75"
                r="70"
              ></circle>
            </svg>
            <svg
              className="loader-circle-over-canvas"
              viewBox="0 0 150 150"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="internal-circle-over-canvas"
                cx="75"
                cy="75"
                r="70"
              ></circle>
            </svg>
          </div>
        }
        {this.props.data?.cotizaciion ? (
          <SidebarQuotation
            handleOpenQuotation={this.handleOpenQuotation}
            isCollapseQuotation={this.state.isCollapseQuotation}
            quotationProperties={this.state.quotationProperties}
            colors={this.props.data.colors}
            handleSendQuotation={this.handleSendQuotation}
            handleRemovePropertyInQuotation={
              this.handleRemovePropertyInQuotation
            }
            isSendQuotation={this.state.isSendQuotation}
            statusQuotation={this.state.statusQuotation}
          />
        ) : null}
        {this.props.data?.cotizaciion &&
        !this.state.isLocation &&
        !this.state.isTownplanning &&
        !this.state.isGallery &&
        !this.state.isAmenities ? (
          <Quotation
            colorsData={this.props.data.colors}
            handleOpenQuotation={this.handleOpenQuotation}
            isCollapseQuotation={this.state.isCollapseQuotation}
          />
        ) : null}
      </div>
    );
  }
}

export default Canvas;
